import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Descope } from '@descope/react-sdk';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useAuth } from '../contexts/AuthContext';

const Login: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading } = useAuth();

  // If already authenticated, redirect to home
  React.useEffect(() => {
    if (isAuthenticated && !isLoading) {
      navigate('/');
    }
  }, [isAuthenticated, isLoading, navigate]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <Card className="w-full max-w-md">
        <CardHeader className="space-y-1">
          <CardTitle className="text-2xl font-bold text-center">
            HubSpot to Stripe Connector
          </CardTitle>
          <CardDescription className="text-center">
            Sign in to access the sync dashboard
          </CardDescription>
        </CardHeader>

        <CardContent>
          <div className="mt-8">
            <Descope
              flowId="sign-up-or-in"
              redirectUrl={`${window.location.origin}/login`}
              onSuccess={(e) => {
                console.log('Login successful:', e.detail.user);
                navigate('/');
              }}
              onError={(e) => {
                console.error('Login error:', e);
              }}
            />
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Login;
